import { makeStylesV5 } from '../../components';
export default makeStylesV5()((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 2,
        color: '#fff',
    }
}));
//# sourceMappingURL=styles.js.map